"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Stepper_1 = __importDefault(require("@mui/material/Stepper"));
var clsx_1 = require("clsx");
require("./stepper.scss");
var component_2023_components_atoms_divider_1 = require("@rentspree/component-2023.components.atoms.divider");
var Stepper = function (_a) {
    var className = _a.className, viewMode = _a.viewMode, restProps = __rest(_a, ["className", "viewMode"]);
    var stepperClassName = 'RSPStepper';
    var combinedClassName = (0, clsx_1.clsx)(className, stepperClassName);
    var isDesktopView = viewMode === 'desktop';
    var layout = isDesktopView ? 'vertical' : 'horizontal';
    var dividerSx = isDesktopView
        ? { width: 'max-content', height: 24, marginLeft: '16px' }
        : { width: 24, height: 'max-content' };
    return ((0, jsx_runtime_1.jsx)(Stepper_1.default, __assign({}, restProps, { className: "".concat(combinedClassName, "-").concat(layout), orientation: layout, connector: (0, jsx_runtime_1.jsx)(component_2023_components_atoms_divider_1.Divider, { orientation: layout, sx: dividerSx }) })));
};
exports.Stepper = Stepper;
//# sourceMappingURL=stepper.js.map